import { css } from "@emotion/css";
import sum from "lodash/sum";
import { useTranslation } from "react-i18next";

import { Stack } from "../../../foundations/grid-layout/Stack";
import { Text } from "../../../foundations/typography/Text";
import { NeutralBadge } from "../../badge/NeutralBadge";

import { colors } from "./utils";

interface DataSet {
  label: string;
  key: string;
  data: number[];
}

interface Props {
  data: DataSet[];
  isVertical?: boolean;
  onClick?: (label: string) => void;
}

export function SummaryOutput(props: Props) {
  const { data, isVertical, onClick } = props;
  const { t } = useTranslation();

  return (
    <Stack
      className={isVertical ? styles.verticalWrapper : styles.horizontalWrapper}
      gap="space-3"
    >
      <Text style="input/label">{t("Task type")}</Text>
      <div className={styles.container}>
        {data?.map?.((set, i: number) => {
          return (
            <div
              key={i}
              className={css(
                styles.row,
                isVertical ? { flexBasis: "48%" } : { flex: "48%" },
                onClick
                  ? {
                      cursor: "pointer",
                      "&:hover": {
                        background: "var(--background-ghost-hover)",
                      },
                    }
                  : {}
              )}
              role="button"
              tabIndex={0}
              onClick={() => onClick?.(set?.key)}
              onKeyDown={() => onClick?.(set?.key)}
            >
              <div className={styles.leftColumn}>
                <div
                  className={css(styles.colorSwatch, {
                    backgroundColor: colors[i],
                  })}
                />
                <div className={styles.label}>
                  <Text style="global/body-secondary">{set.label}</Text>
                </div>
              </div>
              <NeutralBadge type="subtle">{sum(set.data)}</NeutralBadge>
            </div>
          );
        })}
      </div>
    </Stack>
  );
}

const styles = {
  verticalWrapper: css({
    margin: "auto",
    width: "416px",
  }),
  horizontalWrapper: css({
    width: "220px",
  }),
  container: css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    columnGap: "var(--space-4)",
    // rowGap: "var(--space-4)",
    rowGap: "var(--space-2)",
  }),
  row: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "var(--space-1) 0",
  }),
  leftColumn: css({
    display: "flex",
    gap: "var(--space-1)",
    alignItems: "center",
  }),
  colorSwatch: css({
    height: "15px",
    width: "15px",
  }),
  label: css({
    width: "154px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
};
